import WatchMedicalDocuments from '@/components/watch/medicaldocuments/MedicalDocuments'
import WatchMedicalDocumentsView from '@/components/watch/medicaldocuments/MedicalDocumentsView'

export default [
	{
		path: 'medicaldocuments',
		name: 'WatchMedicalDocuments',
		component: WatchMedicalDocuments,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile
		}),
		children: [
			{
				path: ':category_id',
				name: 'WatchMedicalDocumentsView',
				component: WatchMedicalDocumentsView,
				props: (route) => ({
					user_uid: route.params.user_uid,
					watch_id: route.params.watch_id,
					category_id: route.params.category_id
				})
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/watch/medicaldocuments.js